import React, { FC } from 'react';
import clsx from 'clsx';
import Spinner from 'components/Spinner';
import styles from './LoaderOverlay.module.scss';

interface ILoaderOverlayProps {
  loaderClassName?: string;
  fullscreen?: boolean;
}

const LoaderOverlay: FC<ILoaderOverlayProps> = ({ loaderClassName, fullscreen }) => {
  return (
    <div className={clsx(styles.loaderContainer, loaderClassName, fullscreen && styles.fullscreen)}>
      <Spinner size={52} thickness={4} rootClassName={styles.spinnerRoot} />
    </div>
  );
};

export default LoaderOverlay;
